import Footer from '@oneflare/flarekit/lib/components/Footer';
import { memo } from 'react';
// Dynamic imports doesn't work for importing components from node modules
// So generated a component to make it lazy loading

const FooterComponent = () => <Footer />;

export default memo(FooterComponent);
